import { standardParamSerializer } from '..';

export const cmailAccountsParamsSerializer = [
  ...standardParamSerializer,
  { path: 'accountName' },
  { path: 'accountId' },
];
